<template>
    <div class="min-h-screen bg-gray-50">
        <Header />
        <div class="container mx-auto py-6 pb-16">
            <div class="flex flex-col lg:flex-row gap-8">
                <div class="product-detail w-full">
                    <nav class="breadcrumb">
                        <router-link to="/">首页</router-link><span>/</span>
                        <router-link to="/product">数字产品</router-link><span>/</span>
                        <router-link v-if="product" to="/product">{{ getDictLabelByValue(product.category) }}</router-link><span v-if="product">/</span>
                        <span>{{ product ? product.name : '产品详情' }}</span>
                    </nav>

                    <div v-if="product" class="detail-main">
                        <div class="card">
                            <div class="product-top">
                                <div class="product-image">
                                    <img v-if="product.imageUrl" :src="getFullImageUrl(product.imageUrl)" :alt="product.name">
                                    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                                </div>
                                <div class="product-info">
                                    <h1 class="product-name">{{ product.name }}</h1>
                                    <div class="product-tags">
                                        <span>{{ getDictLabelByValue(product.category) }}</span>
                                        <span>{{ getDictLabelByValue(product.domain) }}</span>
                                    </div>
                                    <p class="product-desc-short">{{ product.description }}</p>
                                    <div class="product-meta-row"><strong>供应商：</strong>{{ product && product.companyName ? product.companyName : "暂无" }}</div>
                                    <div class="product-meta-row"><strong>所属领域：</strong>{{ product && getDictLabelByValue(product.category) ? getDictLabelByValue(product.category) : "-" }} / {{ product && getDictLabelByValue(product.domain) ? getDictLabelByValue(product.domain) : "-" }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="card price-card">
                            <div class="card-title">价格信息</div>
                            <div class="price-block">
                                <div v-if="product.discount" class="discount-highlight">{{ discountText(product.discount) }}</div>
                                <div v-if="product.discount" class="price-original-box">
                                    <div class="label">原价</div>
                                    <div class="price-original">&yen;{{ product.price }}</div>
                                </div>
                                <div class="member-price-box">
                                    <div class="label">{{ product.discount ? '会员价' : '价格' }}</div>
                                    <div class="member-price"><small>&yen;</small>{{ product.discount ? product.memberPrice : product.price }}</div>
                                    <div v-if="product.discount" class="member-note">会员享{{ discountText(product.discount) }}优惠</div>
                                </div>
                            </div>
                            <div class="price-actions">
                                <button class="btn-primary" type="button">立即咨询</button>
                                <button class="btn-secondary" type="button" @click="$router.back()">返回列表</button>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-title">产品配置</div>
                            <div class="desc-text">{{ product.config }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">产品描述</div>
                            <div class="desc-text">{{ product.description }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">供应商信息</div>
                            <div class="supplier-info">
                                <div class="supplier-avatar">{{ product && product.companyName ? product.companyName.slice(0, 1) : "" }}</div>
                                <div>
                                    <div class="supplier-name">{{ product && product.companyName ? product.companyName : "暂无供应商" }}</div>
                                    <div class="supplier-desc">优质供应商，产品已入驻数字产品超市</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="not-found">
                        <h2>产品不存在</h2>
                        <p>未找到该产品信息，请返回列表页浏览</p>
                        <router-link to="/product" class="btn-primary">返回产品列表</router-link>
                    </div>
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import {CURRENT_CONFIG} from "@/api/config";
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'
import {api} from "@/api";
export default {
    name: 'ProductDetail.vue',
    components: {
        Header,
        AppFooter
    },
    data() {
        return {
            loading: false,
            BASE_URL: CURRENT_CONFIG.BASE_URL,
            product: {},
            productId: null,
            dictList: []
        }
    },
    computed: {
    },
    mounted() {
        // 从路由参数中获取产品ID
        this.productId = this.$route.params.id;
        // 先获取字典数据，再获取产品详情
        this.getDataDictList().then(() => {
            this.getProductDetail()
        });
    },
    methods: {
        price(value) {
            return value.toLocaleString()
        },
        discountText(value) {
            return `${Number(value).toFixed(1).replace(/\.0$/, '')}折`
        },
        // 根据字典值获取对应的标签文字
        getDictLabelByValue(value) {
            if (!value) return '';
            const dictItem = this.dictList.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        async getProductDetail() {
            this.product = {}
            const result = await api.getProductDetailApi(this.productId)
            if (result.code === 200) {
                this.product = result.data
            }
        },
        // 获取数据字典
        async getDataDictList() {
            this.dictList = [];
            const dictType = 'biz_digital_product_type';
            const result = await api.getDataDictApi(dictType);
            if (result.code === 200) {
                this.dictList = result.rows;
            }
        },
        getFullImageUrl(path) {
            return this.BASE_URL + path
        },
    }
}
</script>
<style scoped>
.product-detail { color: #333; }
.breadcrumb { display: flex; align-items: center; max-width: none; margin: 0 0 24px; padding: 12px 16px; background: #fff; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,.04); font-size: 13px; color: #999; }
.breadcrumb a { color: #2d6bc4; text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb span { margin: 0 6px; }
.detail-main { max-width: 900px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }
.card { background: #fff; border-radius: 12px; padding: 28px; box-shadow: 0 2px 12px rgba(0,0,0,.06); }
.card-title { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; position: relative; }
.card-title::after { content: ''; position: absolute; bottom: -2px; left: 0; width: 40px; height: 2px; background: #2d6bc4; }
.product-top { display: flex; gap: 28px; }
.product-image { width: 320px; height: 240px; flex-shrink: 0; background: linear-gradient(135deg, #e8f0fe, #d4e4fc); border-radius: 12px; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.product-image img { max-height: 100%; max-width: 100%; object-fit: cover; width: auto; }
.product-image svg { width: 100px; height: 100px; color: #aac; }
.product-info { flex: 1; display: flex; flex-direction: column; }
.product-name { font-size: 22px; font-weight: 700; color: #1a1a2e; margin-bottom: 12px; }
.product-tags { display: flex; gap: 8px; margin-bottom: 16px; flex-wrap: wrap; }
.product-tags span { padding: 4px 14px; background: #f0f5ff; color: #2d6bc4; border-radius: 4px; font-size: 13px; font-weight: 500; }
.product-desc-short { font-size: 14px; color: #666; margin-bottom: 20px; line-height: 1.8; flex: 1; }
.product-meta-row { display: flex; gap: 4px; font-size: 13px; color: #999; margin-bottom: 8px; }
.product-meta-row strong { color: #666; }
.price-block { display: flex; align-items: flex-end; gap: 20px; flex-wrap: wrap; }
.label { font-size: 13px; color: #999; margin-bottom: 4px; }
.price-original-box, .member-price-box { display: flex; flex-direction: column; }
.price-original { font-size: 18px; color: #bbb; text-decoration: line-through; }
.discount-highlight { display: inline-flex; align-items: center; justify-content: center; background: #e6453a; color: #fff; padding: 6px 14px; border-radius: 20px; font-size: 14px; font-weight: 600; margin-bottom: 4px; }
.member-price { font-size: 36px; font-weight: 700; color: #e6453a; line-height: 1; }
.member-price small { font-size: 16px; font-weight: 400; }
.member-note { font-size: 12px; color: #2d6bc4; margin-top: 4px; }
.price-actions { display: flex; gap: 12px; margin-top: 16px; }
.btn-primary { padding: 10px 32px; background: #2d6bc4; color: #fff; border: 0; border-radius: 8px; font-size: 15px; cursor: pointer; transition: background .3s; text-decoration: none; display: inline-block; }
.btn-primary:hover { background: #1a3a6b; }
.btn-secondary { padding: 10px 32px; background: #fff; color: #2d6bc4; border: 1px solid #2d6bc4; border-radius: 8px; font-size: 15px; cursor: pointer; transition: all .3s; }
.btn-secondary:hover { background: #f5f8ff; }
.desc-text { font-size: 14px; color: #666; line-height: 2; white-space: pre-wrap; }
.supplier-info { display: flex; align-items: center; gap: 16px; }
.supplier-avatar { width: 56px; height: 56px; background: #f0f5ff; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: #2d6bc4; font-weight: 700; font-size: 20px; }
.supplier-name { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 4px; }
.supplier-desc { font-size: 13px; color: #999; }
.not-found { text-align: center; padding: 80px 20px; background: #fff; border-radius: 12px; }
.not-found h2 { font-size: 24px; color: #999; margin-bottom: 16px; }
.not-found p { color: #999; margin-bottom: 20px; }
@media (max-width: 640px) { .product-top { flex-direction: column; } .product-image { width: 100%; height: 200px; } .price-actions { flex-direction: column; } }
</style>
